module.exports = __webpack_public_path__ + "static/media/RasterText_BUY@3x.b2a48f82.png";